module.exports = __webpack_public_path__ + "img/11-bg.9a0d3436.jpg";